// 항목 이름 복제 시 충돌 없는 새 이름 후보를 만든다.
//
// 규칙:
//   - 1순위 후보: `${baseName}_copy`
//   - 충돌 시  : `${baseName}_copy_2`, `_copy_3`, ... 순으로 비어있는 번호를 찾는다.
//
// 사용 예:
//   suggestDuplicateName('foo', [{name:'foo'}, {name:'foo_copy'}])  // => 'foo_copy_2'
//   suggestDuplicateName('foo', [])                                  // => 'foo_copy'
//
// 백엔드 호출 없이 메모리상 list 만으로 결정 — 사이드바가 이미 list 를 들고 있으므로
// 별도 fetch 없이 충돌 회피가 가능하다.
export function suggestDuplicateName(baseName, existingItems) {
  const used = new Set((existingItems || []).map(it => (it && it.name) || ''))
  const first = `${baseName}_copy`
  if (!used.has(first)) return first
  let i = 2
  // 무한루프 방어 — 안전장치 (현실적으로 도달할 일 없음)
  while (i < 10000) {
    const candidate = `${baseName}_copy_${i}`
    if (!used.has(candidate)) return candidate
    i++
  }
  // 최후의 수단: timestamp
  return `${baseName}_copy_${Date.now()}`
}
